import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { useIntl } from "@edx/frontend-platform/i18n";
import { validateAlternativeEmail } from "./extraValidator";

import { FormGroup } from "../../../common-components";
import { clearRegistrationBackendError } from "../../data/actions";

const AlternativeEmailField = (props) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  const { handleErrorChange } = props;

  const handleOnBlur = (e) => {
    dispatch(clearRegistrationBackendError("alternate_email"));
  };

  const handleOnFocus = () => {
    handleErrorChange("alternate_email", "");
    dispatch(clearRegistrationBackendError("alternate_email"));
  };

  return (
    <FormGroup
      {...props}
      handleBlur={handleOnBlur}
      handleFocus={handleOnFocus}
    />
  );
};

AlternativeEmailField.defaultProps = {
  errorMessage: "",
};

AlternativeEmailField.propTypes = {
  errorMessage: PropTypes.string,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
};

export default AlternativeEmailField;
